import { Component } from '@/types'
import barba from '@barba/core'

// Keep in sync with --md in frontend/css/media-queries.css
const DESKTOP_QUERY = '(min-width: 800px)'

const component: Component = ref => {
  if (!ref.collectionLayoutChanger) return

  ref.collectionLayoutChanger.forEach(form => {
    const inputs = form.querySelectorAll('input')

    function updateDOM(layout: string) {
      ref.main[0].classList.toggle('layout-2', layout === '2')
      ref.main[0].classList.toggle('layout-3', layout === '3')

      inputs.forEach(input => {
        input.checked = input.value === layout
      })
    }

    // The default view is set per collection template in the theme editor and
    // rendered as data attributes on the form. An explicit ?layout= in the URL
    // always wins so shared links keep working.
    function defaultLayout() {
      const isDesktop = window.matchMedia(DESKTOP_QUERY).matches
      const fallback = isDesktop ? form.dataset.defaultDesktop : form.dataset.defaultMobile
      return fallback || '1'
    }

    // initial load
    const url = new URL(window.location.href)
    const initLayout = url.searchParams.get('layout')

    updateDOM(initLayout || defaultLayout())

    form.addEventListener('change', e => {
      const input = e.target as HTMLInputElement
      // update url: the template's default view keeps a clean URL, every other
      // choice is written explicitly so a reload keeps it
      const url = new URL(window.location.href)
      if (input.value === defaultLayout()) {
        url.searchParams.delete('layout')
      } else {
        url.searchParams.set('layout', input.value)
      }
      barba.history.add(url.toString(), 'barba', 'replace')

      updateDOM(input.value)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })
  })
}

export default component
